import { FinnishSSN } from 'finnish-ssn'

export const validate = (ssn) => {
    return FinnishSSN.validate(ssn.trim())
}

export const isMinor = (ssn) => {
    if (!validate(ssn)) return null

    const { ageInYears } = FinnishSSN.parse(ssn.trim())

    return ageInYears < 18
}
